export enum RetailInventoryMenuEnum {
    overview = 0,
    properties,
    departments,
    tenants,
    unit
}
